export default __webpack_public_path__ + "static/media/yamaha-logo.3ee0e326.png";